<template>
  <div class="upload-folder-dialog">
    <div class="function-box">
      <span class="compressed-btn" title="将文件夹压缩成zip格式">
        压缩文件夹：
        <el-switch v-model="isCompressed">
        </el-switch>
      </span>
      <span class="path">
        当前上传路径：{{path}}
      </span>
    </div>
    <UploadFolder :isCompressed="isCompressed" :data="{path}" @handleSuccess="folderUploadSuccess" @handleError="folderUploadError" />
  </div>
</template>

<script>
import UploadFolder from '@/views/fileUpload/components/uploadFolder.vue'
export default {
  name: 'upload-folder-dialog',
  components: {
    UploadFolder
  },
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isCompressed: false
    }
  },
  methods: {
    // 文件夹上传成功
    folderUploadSuccess (data = []) {
      // 获取文件夹或者压缩文件名称
      if (data.length && data[0]) {
        let file = data[0];
        let url = file.url;
        let str = url.split(this.path)[1];
        let name = str.substr(0, str.indexOf('/')) || file.filename;
        this.highLightingName(name);
        this.$emit('close');
        this.$emit('getDirectoryFiles');
        this.$message.success('文件上传成功！')
      }
    },
    // 高亮当前文件
    highLightingName (name) {
      // 设置高亮文件/文件夹名称
      this.$emit('update:name', name);
      // 设置路由参数
      this.$router.push(`/fileManage/projectDetail?path=${this.path}&name=${name}`);
    },
    // 文件夹上传失败
    folderUploadError (err) {
      console.log('uploadRequest error', err);
      this.$message.error('上传文件夹时发生错误！');
    },
  }

}
</script>

<style lang="scss">
.upload-folder-dialog {
  .function-box {
    display: flex;
    align-items: center;
    margin: -25px 0 15px 0;
    font-weight: 600;
    .path {
      margin-left: 20px;
    }
  }
}
</style>